/**
 * [websocket description]
 * @param url {String} 接口的地址，相对根路径
 * @param settings {Object} 请求相关设置
 */
var center = require('message.center');
var reconnectWebsocket = require('reconnectWebsocket');

function websocket(path,settings){
    var protoReg = /^ws:/,
        requestPath;//服务器地址
    if (protoReg.test(path)) {
        if(settings){
            requestPath = path + '/' + settings;
        }else{
            requestPath = path;
        }
    }
    else {
        if(settings){
            requestPath = 'ws://' + path + '/' + settings;
        }else{
            requestPath = 'ws://' + path;
        }
    }

    var websocket = new reconnectWebsocket(requestPath); //创建WebSocket对象
    // websocket.onopen = function (evt) {
    //
    // };
    // websocket.onclose = function (evt) {
    //
    // };
  // websocket.onmessage = function (evt) {
  // //收到服务器消息，使用evt.data提取
  //
  //   console.log(evt.data);
  //
  // };
  // websocket.onerror = function (evt) {
  // //产生异常
  //   console.log(evt);
  // };
    return websocket;
}

module.exports = {
  websocket:websocket,
}



// WEBPACK FOOTER //
// ./src/service/common/socket.js